export default {
    container: {
        padding: 8,
        margin: '5px 0px'
    },
    heading: {
        margin: 0
    },
    list: {
        item: {
            position: 'relative',
            fontWeight: 'bold',
            fontSize: '1.2rem',
            padding: '2rem 1rem 1rem 1rem',
            border: '1px solid rgba(0, 0, 0, 0)',
            margin: '0.5rem 10px 10px 0px',
            backgroundColor: 'white',
            borderRadius: 5,
            boxShadow: 'rgba(0, 0, 0, 0.06) 0px 0.3rem 0.3rem',
        },
        sub: {
            display: 'flex',
            width: '100%',
            marginTop: 8,
            justifyContent: 'space-between',
            fontSize: '1.1rem',
            alignItems: 'center'
        },
        text: {margin: 0},
        btn: {
            position: 'absolute',
            top: 0,
            right: 0,
            cursor: 'pointer',
            padding: 5,
            fontSize: 12,
            borderRadius: '0px 5px 0px 0px'
        }
    }
}